export class IntentAlreadyProcessedError extends Error {
  constructor(id: string) {
    super(
      `Payment Intent ${id} was already proccessed and is no longer valid.`,
    );
    this.name = 'IntentAlreadyProcessedError';
  }
}
